export default {
    LOAD_BANNERS (state, banners) {
        state.items = banners
    }
}